import { combineReducers } from "redux";
import authentication from "./authentication/slice";
import cartItems from "./cartItems/slice";
import settings from "./settings/slice";

// Kept separate from store.ts so test/Storybook code can import the reducers
// without triggering store assembly side-effects (persistStore) which depend
// on a real browser-like storage.
export const reducers = combineReducers({ authentication, settings, cartItems });
